<ul class="gb_langList">
  <ng-container *ngFor="let lang of storeService.languagesCollection">
    <li [ngClass]="lang.default ? 'active' : ''">
      <a href="javascript:void(0);" (click)="setLanguage(lang.code)" title="{{lang.name}}"
         [attr.aria-label]="lang.name" tabindex="0" class="d-flex align-items-center gap-2 ms-2 mb-2">
        <img src="./assets/gb/lang/{{lang.code | lowercase}}.svg" [alt]="lang.name" width="32" height="16">
        {{lang.code}}
      </a>
    </li>
  </ng-container>
</ul>
